import { cmToPx } from 'helpers/utils';
import style from './FenceSlope.module.scss';

const FenceSlope = ({ fenceGroupDetails, className = '' }) => {
  const { maxSlope, elements, settings } = fenceGroupDetails;
  const slopeSizes = elements.map((part) => {
    return `${cmToPx(part.start.x)} ${cmToPx(part.start.y)} L ${cmToPx(part.end.x)} ${cmToPx(part.end.y)}`;
  });

  const directionAsc = settings.slopeDirection === 'asc';

  return (
    <div className={`${style.slope} ${className}`} style={{ height: cmToPx(maxSlope) }}>
      <span>
        Lejtés:
        <br />
        {maxSlope} cm
      </span>
      <svg
        style={{ opacity: 1 }}
        width={cmToPx(settings.maxWidth)}
        height={cmToPx(maxSlope + 10)}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d={`
            M ${slopeSizes.join(' L ')}
            L ${cmToPx(settings.maxWidth)} ${directionAsc ? 0 : cmToPx(maxSlope)}
            L ${cmToPx(settings.maxWidth)} ${cmToPx(maxSlope)}
            L 0 ${cmToPx(maxSlope)}
            Z`}
          fill="#fff"
          stroke="none"
        />
        <path
          d={`M ${slopeSizes.join(' L ')} L ${cmToPx(settings.maxWidth)} ${directionAsc ? 0 : cmToPx(maxSlope)}`}
          style={{ transform: `translate(0, ${cmToPx(10, true)})` }}
          fill="none"
          stroke="#ccc"
          strokeWidth="2"
          strokeDasharray="10,6"
        />
      </svg>
    </div>
  );
};

export default FenceSlope;
